import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faGlobe,
  faLock,
  faPalette,
  faEnvelope,
  faSun,
  faMoon,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "../../redux/reducers/theme-reducer";
import { useTranslation } from "react-i18next";

const SettingsPage = () => {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme);
  const { t } = useTranslation();

  // TODO save prefered theme and retrieve from user profile
  // Load theme from localStorage on initial mount
  React.useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      dispatch(setTheme(savedTheme));
    }
  }, [dispatch]);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    localStorage.setItem('theme', newTheme); // Save theme preference
    dispatch(setTheme(newTheme));
  };

  return (
    <div className="min-h-screen flex flex-col items-center py-4 pt-18 lg:py-28 px-4 sm:px-6 lg:px-8 dark:bg-black bg-gray-100">
      <h1 className="text-4xl font-bold dark:text-white text-gray-900 mb-4">
        {t('settings.title')}
      </h1>
      <p className="text-lg dark:text-zinc-400 text-gray-600 mb-12 max-w-lg text-center">
        {t('settings.description')}
      </p>

      <div className="grid grid-cols-1 gap-6 w-full max-w-3xl">
        {/* Theme Toggle */}
        <div className="dark:bg-slate-900 bg-white shadow-lg rounded-lg p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <FontAwesomeIcon
                icon={faPalette}
                className="dark:text-white text-gray-600 text-2xl"
              />
              <div>
                <h3 className="dark:text-white text-xl font-bold text-gray-800">
                  {t('settings.theme.title')}
                </h3>
                <p className="dark:text-zinc-400 text-sm text-gray-600">
                  {t('settings.theme.description')}
                </p>
              </div>
            </div>
            <button
              className="flex items-center justify-center p-2 rounded-full border border-gray-300 dark:border-gray-600 focus:outline-none"
              onClick={toggleTheme}
            >
              <FontAwesomeIcon
                icon={theme === "dark" ? faSun : faMoon}
                className="text-lg text-gray-800 dark:text-white"
              />
            </button>
          </div>
        </div>

        {/* Account Settings TODO: add this back in
        <div className="dark:bg-slate-900 bg-white shadow-lg rounded-lg p-6">
          <Link to="/settings/manage-profile" className="flex items-center space-x-4">
            <FontAwesomeIcon icon={faCog} className="dark:text-white text-gray-600 text-2xl" />
            <div>
              <h3 className="dark:text-white text-xl font-bold text-gray-800">
                {t('settings.account.title')}
              </h3>
              <p className="dark:text-zinc-400 text-sm text-gray-600">
                {t('settings.account.description')}
              </p>
            </div>
          </Link>
        </div>
        */}

        {/* Language Preferences */}
        <div className="dark:bg-slate-900 bg-white shadow-lg rounded-lg p-6">
          <Link to="/settings/language" className="flex items-center space-x-4">
            <FontAwesomeIcon icon={faGlobe} className="dark:text-white text-gray-600 text-2xl" />
            <div>
              <h3 className="dark:text-white text-xl font-bold text-gray-800">
                {t('settings.language.title')}
              </h3>
              <p className="dark:text-zinc-400 text-sm text-gray-600">
                {t('settings.language.description')}
              </p>
            </div>
          </Link>
        </div>

        {/* MFA Settings TODO: add this back in
        <div className="dark:bg-slate-900 bg-white shadow-lg rounded-lg p-6">
          <Link to="/settings/mfa" className="flex items-center space-x-4">
            <FontAwesomeIcon icon={faLock} className="dark:text-white text-gray-600 text-2xl" />
            <div>
              <h3 className="dark:text-white text-xl font-bold text-gray-800">
                {t('settings.mfa.title')}
              </h3>
              <p className="dark:text-zinc-400 text-sm text-gray-600">
                {t('settings.mfa.description')}
              </p>
            </div>
          </Link>
        </div>
        */}

        {/* Email Notifications TODO: add this back in
        <div className="dark:bg-slate-900 bg-white shadow-lg rounded-lg p-6">
          <Link to="/settings/notifications" className="flex items-center space-x-4">
            <FontAwesomeIcon icon={faEnvelope} className="dark:text-white text-gray-600 text-2xl" />
            <div>
              <h3 className="dark:text-white text-xl font-bold text-gray-800">
                {t('settings.notifications.title')}
              </h3>
              <p className="dark:text-zinc-400 text-sm text-gray-600">
                {t('settings.notifications.description')}
              </p>
            </div>
          </Link>
        </div>
        */}
      </div>
    </div>
  );
};

export default SettingsPage;
